export default "__VITE_ASSET__DJWW5hmX__"